<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2">
          <el-button
            class="goBack"
            style="width:150px"
            @click="goback()"
          >返回上一级</el-button>
        </el-col>
        <!-- <el-col :span="2" :offset="20">
          <el-button style="width:100px"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col> -->
      </el-row>
    <el-dialog title="场地管理"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="100px">
          <el-form-item label="场地名称" prop="name">
            <el-input v-model="formparams.name" placeholder="请输入场地名称"></el-input>
          </el-form-item>
          <el-form-item label="上/下线" v-if="addType==2">
            <el-switch
              v-model="formparams.isWeb"
              active-value= '1'
              inactive-value= '0'
              active-text="上线"
              inactive-text="下线">
            </el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" label="场地名称"></el-table-column>
        <el-table-column prop="stagetype" label="场地类型名称"></el-table-column>
        <el-table-column prop="stagetypeshortname" label="场地类型名称简称"></el-table-column>
        <el-table-column label="上线/下线">
          <template slot-scope="scope">
            <div v-if="scope.row.isWeb == 1">上线</div>
            <div v-else>下线</div>
          </template>
        </el-table-column>
        <el-table-column label="分店编号">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getOnlinePlaceInfo, insertInfS, getShops, updateInfS } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      date:[],//开始时间结束时间
      rules:{
        name:[
          { required: true, message: '请输入场地名称', trigger: 'blur' }
        ],
        shopNum:[
          { required: true, message: '请选择分店', trigger: 'change' }
        ]
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      formparams:{
        isWeb:'',
        name:'',
        stageType:this.$route.query.type,
        stageTypeshortname:this.$route.query.typeshortname,
        shopNum:this.$route.query.shopNum,
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      for (let i = 0; i < this.shopList.length; i++) {
        this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
      }
    } else{
      this.getShopsList()
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    goback(){
      this.$router.go(-1)
      // this.$router.push('/siteList')
    },
    //查询场地
    getTableList(){
      getOnlinePlaceInfo({id:this.$route.query.id}).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops().then((res)=>{
        this.shopList = res.data
        for (let i = 0; i < this.shopList.length; i++) {
          this.titleList.push({value:this.shopList[i].shopNum,text:this.shopList[i].name})
        }
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
      })
    },
    showDialog(){
        this.dialogVisible =true
        this.addType = 1
        this.formparams.name=''
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.name = row.name
      this.formparams.isWeb = row.isWeb.toString()
      this.formparams.shopNum = row.shopNum
    },
    handleRemove(file) {
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          if(this.addType==1){
            insertInfS(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'添加成功'
                  })
                }
                this.getTableList()
            })
          } else {
            updateInfS(this.formparams).then((res)=>{
              if(res.msg == 'success'){
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'修改成功'
                  })
                  this.getTableList()
                }else{
                  this.$message.error(res.data)
                }
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// siteListInfoList.vue?fe1a5830